import { Component, NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MovimentacaoProcessoComponent } from './movimentacao-processo/movimentacao-processo.component';
import { ProcessoComponent } from './processo/processo.component';


const routes: Routes = [
  {path: "juridico/:id", component: ProcessoComponent},
  {path: "movimentacao/:id", component: MovimentacaoProcessoComponent}
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class JuridicoRoutingModule { }
